// @flow

import axios from 'axios';
import { Map } from 'immutable';
import jwt from 'jsonwebtoken';
import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAIL,
  SIGN_OUT,
  AXIOS_INSTANCE,
  ERROR,
  LOADING,
  TOKEN,
  CHANGE_PASSWORD_MODAL_VISIBLE,
  CHOSE_PROJECT_SUCCESS,
  CHOSE_PROJECT_FAIL,
  REGISTER_GUEST_SUCCESS,
  REGISTER_GUEST_FAIL,
  CLEAR_MESSAGE,
  CLEAR_PROJECT,
  GET_PROJECTS,
  INITIAL_PASSWORD_CHANGED,
  SET_PROJECT
} from './../types/auth';
import type { AuthAction } from './../actions/auth';
import { getBaseUrl } from './domainProperties';

const BASE_URL = getBaseUrl();
let emptyAxiosInstance = axios.create({
    baseURL: BASE_URL
});
let axiosInstance = emptyAxiosInstance;
let roles = '';
let userName = '';
let userEmail = '';
let token = localStorage.getItem(TOKEN);
let isSignedIn = localStorage.getItem('isSignedIn') || 'false';
const chosenProject = JSON.parse(localStorage.getItem('chosenProject')) || null;
const initialPasswordChanged = JSON.parse(localStorage.getItem('initialPasswordChanged')) || false;

let decoded = ''
if (token) {
    decoded = jwt.decode(token);
} 

if (decoded) {
  const decoded = jwt.decode(token);
  roles = decoded.roles;
  userName = decoded.sub;
  userEmail = decoded.email;

  const expirationDate = decoded.exp * 1000;
  if (isSignedIn === 'true' && expirationDate - Date.now() > 0) {
    axiosInstance = axios.create({
      baseURL: BASE_URL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(TOKEN)}`
      }
    });
  } else {
    isSignedIn = 'false';
  }
} else {
  isSignedIn = 'false';
}

const INITIAL_MAP = Map({
  [AXIOS_INSTANCE]: axiosInstance,
  [LOADING]: false,
  [CHANGE_PASSWORD_MODAL_VISIBLE]: false,
  'message': {
    type: 'error',
    text: '',
  },
  'isSignedIn': isSignedIn,
  'passwordToken': null,
  'initialPasswordChanged': initialPasswordChanged,
  'chosenProject': chosenProject,
  'roles': roles,
  'userName': userName,
  'userEmail': userEmail
});

const AuthReducer = (state: Map<string, string | boolean | Object> = INITIAL_MAP, action: AuthAction) => {
  switch (action.type) {
    case CLEAR_MESSAGE:
      return state
        .set('message',
          {
            type: 'error',
            text: ''
          });

    case SIGN_IN:
      return state
        .set(AXIOS_INSTANCE, emptyAxiosInstance)
        .set('chosenProject', null)
        .set('message',
          {
            type: 'error',
            text: '',
          })
        .set(LOADING, true);

    case SIGN_IN_SUCCESS:
      const { remember, projects, passwordChanged, passwordToken } = action.userData;
      axiosInstance = action.axiosInstance;
      token = action.token;

      if (remember) {
        localStorage.setItem('isSignedIn', 'true');
      }
      localStorage.setItem('token', token);
      localStorage.setItem('userProjects', JSON.stringify(projects));
      localStorage.setItem('initialPasswordChanged', passwordChanged);

      const decoded = jwt.decode(token);
      const { roles, email, sub } = decoded;

      return state
        .set('initialPasswordChanged', passwordChanged)
        .set('passwordToken', passwordToken)
        .set('isSignedIn', 'true')
        .set('axiosInstance', axiosInstance)
        .set('userProjects', projects)
        .set('chosenProject', null)
        .set('message',
          {
            type: 'error',
            text: '',
          })
        .set('loading', false)
        .set('roles', roles)
        .set('userName', sub)
        .set('userEmail', email)

    case SIGN_IN_FAIL:
      return state
        .set('message',
          {
            type: 'error',
            text: action[ERROR],
          })
        .set(AXIOS_INSTANCE, emptyAxiosInstance)
        .set(LOADING, false);

    case CHOSE_PROJECT_SUCCESS:
      const { project } = action;
      axiosInstance = action.axiosInstance;
      token = action.token;

      localStorage.setItem('token', token);
      localStorage.setItem('chosenProject', JSON.stringify(project));
      return state
        .set('chosenProject', project)
        .set('axiosInstance', axiosInstance)
        .set('message',
          {
            type: 'error',
            text: ''
          })

    case CHOSE_PROJECT_FAIL:
      return state
        .set('message',
          {
            type: 'error',
            text: action[ERROR]
          },
        )

    case SET_PROJECT:
        localStorage.setItem('chosenProject', JSON.stringify(action.project));
        return state
            .set('chosenProject', action.project);   

    case CLEAR_PROJECT:
      return state
        .set('chosenProject', null)

    case SIGN_OUT:
      localStorage.removeItem('isSignedIn');
      localStorage.removeItem('userProjects');
      localStorage.removeItem('token');
      localStorage.removeItem('initialPasswordChanged');
      localStorage.removeItem('chosenProject');
      return state
        .set('isSignedIn', 'false')
        .set(AXIOS_INSTANCE, emptyAxiosInstance)
        .set('message',
          {
            type: 'error',
            text: '',
          })
        .set(LOADING, false)
        .set('chosenProject', null)
        .set('userProjects', []);

    case REGISTER_GUEST_SUCCESS:
      return state
        .set('message',
          {
            type: 'info',
            text: `User ${action.login} created`,
          })

    case REGISTER_GUEST_FAIL:
      return state
        .set('message',
          {
            type: 'error',
            text: action[ERROR]
          })

    case GET_PROJECTS:
      return state
        .set('userProjects', action.newProjects)

    case INITIAL_PASSWORD_CHANGED:
      localStorage.setItem('initialPasswordChanged', 'true');
      return state
        .set('initialPasswordChanged',true)

    default:
      return state;
  }
};

export default AuthReducer;


// WEBPACK FOOTER //
// ./src/reducers/auth.jsx